import { useState, useEffect } from 'react';
import Addcomment from '../Services/AddComment';
import Getcomments from '../Services/Getcomments';
import GetAllPosts from '../Services/GetAllPosts';
import GetPost from '../Services/GetPosts';
import fetchlatestposts from '../Services/LatestPosts';
import Search from '../Services/Search';
import SectorPosts from '../Services/SectorPost';

// Generic fetch hook
const useFetchData = (fetchFunction, params = null) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchFunction(params);
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fetchFunction, params]);

  return { data, error, loading };
};

// Specific hooks using the generic fetch hook
export const useAddComment = (requestBody) => useFetchData(Addcomment, requestBody);
export const useGetComments = (id) => useFetchData(Getcomments, id);
export const useGetAllPosts = () => useFetchData(GetAllPosts);
export const useGetPost = (id) => useFetchData(GetPost, id);
export const useFetchLatestPosts = () => useFetchData(fetchlatestposts);
export const useSearch = (query) => useFetchData(Search, query);
export const useSectorPosts = (category) => useFetchData(SectorPosts, category);
